import { render, staticRenderFns } from "./region-add.vue?vue&type=template&id=da667114&scoped=true&"
import script from "./region-add.vue?vue&type=script&lang=js&"
export * from "./region-add.vue?vue&type=script&lang=js&"
import style0 from "./region-add.vue?vue&type=style&index=0&id=da667114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da667114",
  null
  
)

export default component.exports